import   React                    ,
       { useState                 ,
         useEffect                }  from 'react';

import   classNames                  from 'classnames';

import   styles                      from './ImageSheet.module.scss';
import   { MediaGuideState }         from './MediaGuideBanner';

import { useTypedSelector         }  from '../../../store/useTypeSelector';
import { RootState                }  from '../../../store/generalReducer';

import   Field                       from '../../widget/inputs/Field';
import   FieldImage                  from '../../widget/inputs/FieldImage';
import   Label                       from '../../widget/dataDisplay/labels/Label';
import   CreationIp                     from '../../widget/dataDisplay/labels/CreationIp';
import   TextArea                    from '../../widget/inputs/TextArea';
import   Toggle                      from '../../widget/inputs/Toggle';
import   Trigger                     from '../../widget/actuators/Trigger';
import   WidgetFrame                 from '../../widget/navigation/WidgetFrame';
import   Window                      from '../../widget/windows/window';
import { DownloadProgress         }  from '../../widget/gauge/ProgressBar';

import { Image                    ,
         initializedImage         }  from '../../../dataTypes/mediaManagment/image_types';

import { testTitle                      ,
         testDescription                ,
         testImageFileToUpload                   }  from '../../../dataTypes/mediaManagment/video_validators';

import { convertDateToString    }  from '../../../dataTypes/timeManagment/utils';


import { updateImage              ,
         createImage              ,
         getImageById             ,
         downloadImageBlob        ,
         getImageUsage            }  from '../../../backendServices/mediaManagment/api_image';



import { getUploadsByEntityId     }  from '../../../store/fileManagment/actions';
import { UploadStatus             }  from '../../../store/fileManagment/types';

export interface ImageSheetProps {
                                   image?    : Image;
                                   onCreate? : ( id: number ) => void
                                   onEdit?   : ( id: number ) => void ;
                                   // Création guidée (MediaSheet) : où en est la saisie.
                                   onGuideState? : ( state: MediaGuideState ) => void
                                 }

export const ImageSheet = ({ image    ,
                             onCreate ,
                             onEdit   ,
                             onGuideState }: ImageSheetProps) => {

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);
  useTypedSelector((state: RootState) => state.mediaListReducer);
  // Valeur inutilisée, mais l'abonnement est conservé : le retirer changerait
  // la fréquence de rendu du composant.
  useTypedSelector((state: RootState) => state.mediaCategoryReducer);

  
  const isEditMode = image !== undefined;

  const initialImage: Image = isEditMode ? image! : initializedImage ();

  const [ id                       , setId                       ] = useState (initialImage.id);
  const [ uuid                     ] = useState (initialImage.uuid);
  const [ creationDate             ] = useState (initialImage.creationDate);
  const [ active                   , setActive                   ] = useState (initialImage.active);
  const [ title                    , setTitle                    ] = useState (initialImage.title);
  const [ description              , setDescription              ] = useState (initialImage.description);
  const [ categoriesIds            ] = useState (initialImage.categoriesIds);
  const [ keywordsIds              ] = useState (initialImage.keywordsIds);

  const [ imageUsage               , setImageUsage               ] = useState<number[]>([]);
  
  const [ imageFileToUpload        , setImageFileToUpload        ] = useState<File | null>(null);
  const [ imageSrc                 , setImageSrc                 ] = useState (  ''   );
  const [ imageFileName            , setImageFileName            ] = useState('');
  const [ imageLoading             , setImageLoading             ] = useState ( false );
  const [ imageProgress            , setImageProgress            ] = useState<DownloadProgress | null>(null);

  const [ titleMessage             , setTitleMessage             ] = useState ( '' );
  const [ descriptionMessage       , setDescriptionMessage       ] = useState ( '' );
  const [ imageFileToUploadMessage , setImageFileToUploadMessage ] = useState ( '' );

  const [ numberOfModifiedFields   , setNumberOfModifiedFields   ] = useState (   0   );
  const [ saved                    , setSaved                    ] = useState ( false );
  const [ progress                 , setProgress                 ] = useState (   0   );
  const [ error                    , setError                    ] = useState ( false );
  const [                  , setErrorMsg                 ] = useState (  ''   );
  const [ formError                , setFormError                ] = useState ( false );
  const [ saveButtonLock           , setSaveButtonLock           ] = useState ( false )
  const [ cancelAction             , setCancelAction             ] = useState ( false );

  const [ warningShow              , setWarningShow              ] = useState ( false );

  useEffect(() => {
    if (onGuideState) onGuideState({ title, categoryChosen: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  let warningShowLock: boolean = false
  let imageSheetId: number = 0

  const loadImageBlob = async () => {
    
    console.log ('loadImageBlob', initialImage.id)

    if (imageLoading || !isEditMode || imageSrc) return; // Ne charge qu'une fois
    
    setImageLoading(true);
    setImageProgress({ loaded: 0, total: 0 });
    
    try
     {
      const getImageByIdResult = await getImageById(initialImage.id);

      console.log ('loadImageBlob', getImageByIdResult)

      if (getImageByIdResult.code === 1)
       {
        const completeImageStruct = await downloadImageBlob ( getImageByIdResult.payload                    ,
                                                              (progress) => { setImageProgress(progress); } );

        console.log ('loadImageBlob', completeImageStruct)

        if (completeImageStruct.objectURL)
              {
               setImageSrc(completeImageStruct.objectURL);
               setImageFileName(completeImageStruct.imageFile ?? "");
              }
         else {
               console.error("objectURL is undefined");
              }
       }
     }
    catch (error)
     {
      console.error("Erreur lors du chargement de l'image:", error);
     }
    finally
     {
      setImageLoading(false);
      setImageProgress(null);
     }
  };

  const initImageUsage = async () => {
	  
	const getImageUsageResult = await getImageUsage (initialImage.id)
	
    console.log ('initImageUsage', getImageUsageResult)
	
	if ( getImageUsageResult.code === 1 )
	 {
	  setImageUsage ( getImageUsageResult.payload )
	 }
	  
  }

  // Chargement automatique avec délai de 100ms pour ne pas bloquer le rendu
  useEffect(() => {
    if (isEditMode && initialImage.imageFile) {
      const timer = setTimeout(() => {
        loadImageBlob();
      }, 100);
      
      return () => clearTimeout(timer);
    }
	
  }, []); // Uniquement au montage

  
  useEffect(() => {
	initImageUsage()
  }, []); // Uniquement au montage

  // Suivi de la progression de l'upload de l'image (chunké, en arrière-plan) via le store Redux
  // Filtré sur le type : une vidéo de même id remonterait sinon ici.
  const imageUploads = useTypedSelector((state: RootState) => getUploadsByEntityId(state, id).filter(upload => upload.entityType === 'image'));

  useEffect(() => {
    if (imageUploads.length > 0)
     {
      const currentUpload = imageUploads[0];

      // Un upload terminé reste dans le store : rouvrir la fiche ne doit pas rallumer
      // la fenêtre de progression (sans bouton, elle bloquait la fiche à 95 %).
      if ( [UploadStatus.COMPLETED, UploadStatus.CANCELLED, UploadStatus.FAILED].includes(currentUpload.status) )
       {
        setProgress(0);
       }
      else if (currentUpload.progress > 0)
       {
        setProgress(currentUpload.progress);
       }
     }
  }, [imageUploads]);

  // Nettoyage du blob au démontage
  useEffect(() => {
    return () => {
      if (imageSrc && imageSrc.startsWith('blob:')) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [imageSrc]);

  ///// Gestion de la vérification avant sauvegarde

  const check = (): boolean => {
    
    let test = true;

    const mess = testTitle ( title )
    
    setTitleMessage ( mess )
    
    test = test && ( mess === '' )

    if (imageSrc === '' && imageFileToUpload === null) 
          {
           setImageFileToUploadMessage("Il manque l'image");
           test = test && false;
          } 
     else {
           setImageFileToUploadMessage("");
           test = test && true;
		   
		   console.log ('check', isEditMode, imageUsage, imageUsage.length)
		   
		   if ( isEditMode && imageUsage.length > 0 )
		    {
			 setWarningShow (true)
			 warningShowLock = true  // warningShow ne se met pas à jour tout de suite
			                         // donc save se lance quand même !!!
			}
          }

    return test    
  }

  ///// Gestion de la sauvegarde
  
  const save = async () => {

    console.log ('ImageSheet save authentication', authentication)

    if ( numberOfModifiedFields > 0 )
          {
           const result = isEditMode ?

                     await updateImage ( id                       ,
					                     active                   ,
                                         title                    ,
                                         description              ,
                                         imageFileToUpload        ,
                                         categoriesIds            ,
                                         keywordsIds              ,
                                         false                    ,
                                         authentication.admin?.id )

                     :

                     await createImage ( active                   ,
                                         title                    ,
                                         description              ,
                                         imageFileToUpload        , 
                                         categoriesIds            ,
                                         keywordsIds              ,
                                         false                    ,
                                         authentication.admin?.id )

                if ( result.code === 1 )
                 {
                  imageSheetId = isEditMode ? id : result.payload

                  if ( !isEditMode ) { setId ( result.payload ); } // permet de suivre la progression de l'upload en arrière-plan

                  setSaved    (true);
                  setError    (false);
                  setNumberOfModifiedFields (0);
                 }
                  
           else if ( result.code < 1)
                 {
                  setSaved    (true); // On arrête d'afficher la progression
                  setProgress (0)
                  setError    (true);
                  setErrorMsg (result.comment);
                 }
          }
     else {
           setSaveButtonLock (false)
          }
  }

  const handleActiveChange = ( newState: boolean , id?: number | undefined) => {

    const fieldIsAlreadyModified = active !== initialImage.active;
    setActive (newState)

    if ( newState === initialImage.active &&  fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => Math.max(0, prev - 1)); }
    if ( newState !== initialImage.active && !fieldIsAlreadyModified) { setNumberOfModifiedFields(prev => prev + 1);              }
  }

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    const fieldIsAlreadyModified = title !== initialImage.title

                      setTitle  ( e.target.value )
    setTitleMessage ( testTitle ( e.target.value ) )

    if ( e.target.value === initialImage.title &&  fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields - 1 ) }
    if ( e.target.value !== initialImage.title && !fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields + 1 ) }
  }

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {

    const fieldIsAlreadyModified = description !== initialImage.description

                            setDescription  ( e.target.value )
    setDescriptionMessage ( testDescription ( e.target.value ) )

    if ( e.target.value === initialImage.description &&  fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields - 1 ) }
    if ( e.target.value !== initialImage.description && !fieldIsAlreadyModified ) { setNumberOfModifiedFields ( numberOfModifiedFields + 1 ) }
  }

  const handleImageFileToUploadChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    if (event && event.target && event.target.files) {
      setImageFileToUpload(event.target.files[0]);
      setImageFileToUploadMessage(testImageFileToUpload(event.target.files[0]));
      setNumberOfModifiedFields(prev => prev + 1);
    }
  };

  const handleSaveActionButton = () => {

    if ( check() )
          {
           if ( !saveButtonLock )
                 {
                  setSaveButtonLock (true)
				  
				  if ( !warningShowLock )
				   {
                    save ()
				   }
                 }
            else {
                  console.log ("LOCK")
                 }
          }
     else {
           setFormError (true)
          }
  }

  const handleCreationAckButton = () => {
      
    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( imageSheetId )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( imageSheetId )
            }
          }
  }

  const handleErrorAckButton = () => {

    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleFormErrorAckButton = () => {

     setFormError (false)
  }

  ///// Gestion du bouton [ANNULER] qui permet de sortir de la saisie de la fiche
  
  const handleCancelActionButton = () => {

    setCancelAction (true)
  }

  const handleCancelButton_cancelAction = () => {

    setCancelAction (false)
    setSaved (false)
    setProgress (0)
    setSaveButtonLock (false)
    window.scroll(0, 0);
  }

  const handleValidButton_cancelAction = () => {

    setCancelAction (false)

    if ( isEditMode )
          {
           if ( onEdit )
            {
             onEdit ( 0 )
            }
          }
     else {
           if ( onCreate )
            {
             onCreate ( 0 )
            }
          }
  }

  const handleWarningAckButton = () => {
	  
    setWarningShow (false)	  
    warningShowLock = false
    save ()
	
  }
  
  return (

            <div className={classNames(styles.root)}>

              {
               warningShow &&
               <Window message                 = {<>Cette image est utilisée dans d'autres<br/>
			                                         médias qui devront être retranscodés</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleWarningAckButton}   />
              }

              {
               formError &&
               <Window message                 = {<>La fiche contient des erreurs</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleFormErrorAckButton}   />
              }
             
              {
               !saved && (progress > 0) &&
               <Window message     = {<>Les éléments de la fiche sont en cours d'upload<br/>{`${ (progress * 0.95).toFixed(0) }%`} effectués</>}
                       messageType = "information"   />
              }

              {
               saved && error &&
               <Window message                 = {<>Une erreur est survenue lors de la création de la fiche</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleErrorAckButton}   />
              }

              {
               saved && !error &&
               <Window message                 = {isEditMode ? <>Fiche modifiée</> : <>Fiche créée</>}
                       messageType             = "information"
                       onClickOnValidateButton = {handleCreationAckButton}
                       validButtonText         = "Ok" />
              }

              {
               cancelAction &&
               <Window message                 = {<>Etes-vous sûr de vouloir annuler vos saisies ?</>}
                       messageType             = "question"
                       onClickOnCancelButton   = {handleCancelButton_cancelAction}
                       onClickOnValidateButton = {handleValidButton_cancelAction}   />
              }

              <div className={classNames(styles.contain)}>

                {/* Même présentation que la fiche vidéo : Id / Uuid / Date / IP dans un
                    bandeau à part, au-dessus du bloc des éléments du média. */}
                {
                 isEditMode &&
                 <div className={classNames(styles.topBar)}>
                   <WidgetFrame name               = "Id :"
                                error              = ""
                                labelTextPosition  = "right"
                                labelBlockPosition = "left" >
                     <p className = {classNames(styles.text)}>{id}</p>
                   </WidgetFrame>
                   <WidgetFrame name               = "Uuid :"
                                error              = ""
                                labelTextPosition  = "right"
                                labelBlockPosition = "left" >
                     <p className = {classNames(styles.text)}>{uuid}</p>
                   </WidgetFrame>
                   <Label value = {`Date de création : ${convertDateToString(creationDate, 'dd/MM/yyyy HH:mm')}`} />
                   <CreationIp ipAddress = {initialImage.creationIpAddress} />
                 </div>
                }

                <div className={classNames(styles.form)}>

                  <div className={classNames(styles.active)}>
                    <WidgetFrame name               = "Actif :"
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame)} >
                      <Toggle checked  = {active}
                              onChange = {handleActiveChange}
                              form     = "switch" />
                    </WidgetFrame>
                  </div>
				  
                  <div className={classNames(styles.left)}>
				
                    <div className={classNames(styles.title)} data-guide="title">
                      <WidgetFrame name               = "Titre :"
                                   error              = {titleMessage}
                                   labelTextPosition  = "right"
                                   labelBlockPosition = "left"
                                   classNameGrid      = {classNames(styles.grid_frame)} >
                        <Field  type          = "text"
                                placeholder   = ""
                                value         = {title}
                                onChange      = {handleTitleChange} />
                      </WidgetFrame>
                    </div>

                    <div className={classNames(styles.description)}>
                      <WidgetFrame name               = {onGuideState ? "Description (facultatif) :" : "Description :"}
                                   error              = {descriptionMessage}
                                   labelTextPosition  = "right"
                                   labelBlockPosition = "left"
                                   classNameGrid      = {classNames(styles.grid_frame)} >
                        <TextArea placeholder   = ""
                                  value         = {description}
                                  onChange      = {handleDescriptionChange} />
                      </WidgetFrame>
                    </div>
				  
                  </div>

                  <div className={classNames(styles.image)}>
                    <WidgetFrame name               = "Image :"
                                 error              = {imageFileToUploadMessage}
                                 labelTextPosition  = "right"
                                 labelBlockPosition = "left"
                                 classNameGrid      = {classNames(styles.grid_frame)} >
                      <FieldImage value        = {imageFileName}
                                  mediaURL     = {imageSrc}  
                                  onChange     = {handleImageFileToUploadChange}
                                  isLoading    = {imageLoading}
                                  loadProgress = {imageProgress} />
                    </WidgetFrame>
                  </div>

                  <div className={classNames(styles.buttons)}>
                    <div className={classNames(styles.bloc)}>
                      <Trigger name    = "Annuler" 
					           onClick = {handleCancelActionButton} 
							   variant = "tailwind2" />
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <Trigger {...(isEditMode && numberOfModifiedFields > 0 ? { buttonBackgroundColor: "#DC2626", buttonBackgroundHoverColor: "#B91C1C", buttonForegroundColor: "#fff", buttonForegroundHoverColor: "#fff" } : {})} name    = {isEditMode?`Enregistrer${numberOfModifiedFields > 0 ? ` (${numberOfModifiedFields})` : ""}`:"Créer"} 
					           onClick = {handleSaveActionButton} 
							   variant = "tailwind2"  
							   unavailable={isEditMode && numberOfModifiedFields === 0} />
                      &nbsp;&nbsp;
                      {
                       numberOfModifiedFields > 0 && isEditMode &&
                       ( <p className={styles.modBadge} > {numberOfModifiedFields} modification{numberOfModifiedFields > 1 ? "s" : ""} </p> )
                      }
                    </div>
                  </div>
				
                </div>
              </div>
			  
            </div>

         );


};


export default ImageSheet;